import { Button } from "@/components/ui/button";
import { LogIn, Link2 } from "lucide-react";
import { useI18n } from '@/hooks/useI18n';

interface SendQuoteChoiceScreenProps {
  onSelectEmailFlow: () => void;
  onSelectLinkFlow: () => void;
}

export const SendQuoteChoiceScreen = ({
  onSelectEmailFlow,
  onSelectLinkFlow,
}: SendQuoteChoiceScreenProps) => {
  const { t } = useI18n();

  return (
    <div className="space-y-6 px-6 py-8">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold text-gray-900">
          {t('itinerary.chooseShareMethod')}
        </h2>
        <p className="text-gray-600">
          {t('itinerary.chooseShareMethodDescription')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Path 1: condivisione in piattaforma (account cliente) */}
        <button
          onClick={onSelectEmailFlow}
          className="group relative flex flex-col items-center p-8 border-2 border-gray-200 rounded-xl hover:border-black hover:shadow-lg transition-all duration-200 bg-white"
        >
          <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors">
            <LogIn className="h-8 w-8 text-blue-600 group-hover:text-white transition-colors" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {t('itinerary.sendQuoteViaEmail')}
          </h3>
          <p className="text-sm text-gray-600 text-center">
            {t('itinerary.sendQuoteViaEmailDescription')}
          </p>
        </button>

        {/* Path 2: Generate Share Link */}
        <button
          onClick={onSelectLinkFlow}
          className="group relative flex flex-col items-center p-8 border-2 border-gray-200 rounded-xl hover:border-black hover:shadow-lg transition-all duration-200 bg-white"
        >
          <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-4 group-hover:bg-green-600 transition-colors">
            <Link2 className="h-8 w-8 text-green-600 group-hover:text-white transition-colors" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {t('itinerary.generateShareLink')}
          </h3>
          <p className="text-sm text-gray-600 text-center">
            {t('itinerary.generateShareLinkDescription')}
          </p>
        </button>
      </div>
    </div>
  );
};
